
import animatedArrowWithText from "../common/animated-arrow-with-text.vue";
import { mapState, mapActions } from "vuex";
import NoDataLabel from "../common/no-data-label.vue";
export default {
  components: { animatedArrowWithText, NoDataLabel },
  data() {
    return {
      categories: [
        { value: "new_order", text: "New Order" },
        { value: "preparing", text: "Preparing" },
        { value: "ready_for_delivery", text: "Ready for delivery" },
        { value: "picked_up", text: "Picked Up" },
        { value: "completed", text: "Completed" }
      ],
      variations: [10, 20, 3, 8],
      series: [
        {
          name: "Orders",
          data: []
        }
      ],
      chartOptions: {
        colors: ["#008FFB", "#008FFB", "#008FFB", "#008FFB", "#28D484"],
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: "25px",
            distributed: true,
            dataLabels: {
              position: "top" // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          // formatter: function(val) {
          //   return val + "%";
          // },
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"]
          }
        },

        xaxis: {
          categories: [],
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5
              }
            }
          },
          tooltip: {
            enabled: true
          }
        },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          labels: {
            show: false
          }
        },
        legend: {
          show: false
        }
        // title: {
        //   text: "Monthly Inflation in Argentina, 2002",
        //   floating: true,
        //   offsetY: 330,
        //   align: "center",
        //   style: {
        //     color: "#444"
        //   }
        // }
      }
    };
  },
  computed: {
    ...mapState("report", ["orderStages", "orderStagesLoading"])
  },
  mounted() {
    this.fetchOrderStages();
  },
  methods: {
    ...mapActions("report", ["getOrderStages"]),
    async fetchOrderStages(backgroundLoad = true) {
      await this.getOrderStages({
        backgroundLoad
      });
      this.chartOptions.xaxis.categories = this.categories.map((el) => el.text);
      this.series[0].data = this.categories.map(
        (el) => this.orderStages[el.value]
      );
      this.variations = [];
      this.series[0].data.forEach((curr, index) => {
        const next = this.series[0].data[index + 1];
        if (next) {
          this.variations.push(
            this.roundNumberWithTwoDecimal((next / curr) * 100) + "%"
          );
        }
      });
    }
  }
};
